import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'
import { Check as CheckIcon } from '@material-ui/icons'

import { LoadingFeedback } from 'components'
import { FantasyDpoForm } from '..'

import { useForm, FormContext } from 'react-hook-form'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import schema from './schema'

import helpers from 'helpers'
import constants from 'constants/index'

const DialogDpoFantasy = ({ refresh, open, setOpen, outsourcedDpo }) => {
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const { handleSubmit, control, errors } = useForm({
    validationSchema: schema,
    defaultValues: {
      fantasyDpos: !isEmpty(outsourcedDpo?.fantasyDpos)
        ? helpers.fantasyDpos.mountDefaultValues(outsourcedDpo.fantasyDpos)
        : [constants.fantasyDpo.DEFAULT_DPO_VALUES],
    },
  })

  const handleClose = () => {
    setOpen(false)
  }

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      const fantasyDposToCreate = data.fantasyDpos.filter(
        (fantasyDpo) => !fantasyDpo.id,
      )

      const fantasyDposToUpdate = data.fantasyDpos.filter(
        (fantasyDpo) => !!fantasyDpo.id,
      )

      if (!isEmpty(fantasyDposToCreate)) {
        await service.dponet.fantasyDpos.create({
          data: {
            fantasyDpos: fantasyDposToCreate,
          },
          outsourcedDpoId: outsourcedDpo?.id,
        })
      }

      if (!isEmpty(fantasyDposToUpdate)) {
        await service.dponet.fantasyDpos.manage({
          data: {
            fantasyDpos: fantasyDposToUpdate,
          },
          outsourcedDpoId: outsourcedDpo?.id,
        })
      }

      snackbar.open({
        message: `DPO(s) Fantasias gerenciados com sucesso`,
        variant: 'success',
      })

      refresh()

      setOpen(false)
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <LoadingFeedback open={loading} />
      <DialogTitle disableTypography>
        <Box>
          <Typography variant="h4">Adicionar DPO Fantasia</Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <FormContext control={control} errors={errors}>
          <FantasyDpoForm disabled={loading} />
        </FormContext>
      </DialogContent>
      <Box display="flex" justifyContent="flex-end" my={2} mr={2}>
        <Button
          variant="outlined"
          type="button"
          onClick={handleClose}
          disableElevation
        >
          FECHAR
        </Button>

        <Box pl={3}>
          <Button
            startIcon={<CheckIcon />}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            color="primary"
            disableElevation
            disabled={loading}
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}

DialogDpoFantasy.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  refresh: PropTypes.func,
  outsourcedDpo: PropTypes.object,
}

DialogDpoFantasy.defaultProps = {
  open: false,
  setOpen: () => {},
  outsourcedDpo: {},
  refresh: () => {},
}

export default DialogDpoFantasy
